module.exports = __webpack_public_path__ + "public/img/wyt_course3.3c7aae72.png";